import { FC } from 'react';
import { BlackCheckIcon } from '../../../../assets/images/countryList';
import './blackCheck.scss';

interface IBlackCheck {
  checked?: boolean;
  handleChangeCheck?: () => void;
}

const BlackCheck: FC<IBlackCheck> = ({ checked, handleChangeCheck }: IBlackCheck) => {
  return (
    <div
      id="blackCheck"
      onClick={() => {
        if (handleChangeCheck) handleChangeCheck();
      }}
    >
      {checked ? <BlackCheckIcon /> : <div className="noBlackCheck" />}
    </div>
  );
};

export default BlackCheck;
